/// <reference types="@arcgis/map-components" preserve="true" />
import React from "react";
import { createComponent } from "@lit/react";
import { makeReactWrapperFactory, getReactWrapperOptions } from "@arcgis/lumina";
const createWrapper = /*@__PURE__*/ makeReactWrapperFactory(React, createComponent);
export const ArcgisAreaMeasurement2d = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-area-measurement-2d", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisAreaMeasurement3d = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-area-measurement-3d", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisAttachments = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-attachments", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisBasemapGallery = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-basemap-gallery", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisBasemapLayerList = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-basemap-layer-list", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisTriggerAction: "arcgisTriggerAction",
}));
export const ArcgisBasemapToggle = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-basemap-toggle", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisBookmarks = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-bookmarks", {
    onArcgisEdit: "arcgisEdit",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSelect: "arcgisSelect",
}));
export const ArcgisBuildingExplorer = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-building-explorer", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisCatalogLayerList = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-catalog-layer-list", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisTriggerAction: "arcgisTriggerAction",
}));
export const ArcgisCompass = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-compass", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisCoordinateConversion = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-coordinate-conversion", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisDaylight = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-daylight", {
    onArcgisReady: "arcgisReady",
}));
export const ArcgisDirectionalPad = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-directional-pad", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisDirections = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-directions", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisDirectlineMeasurement3d = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-directline-measurement-3d", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisDistanceMeasurement2d = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-distance-measurement-2d", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisEditor = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-editor", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisElevationProfile = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-elevation-profile", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisExpand = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-expand", {
    onArcgisReady: "arcgisReady",
}));
export const ArcgisFeature = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-feature", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisFeatureForm = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-feature-form", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSubmit: "arcgisSubmit",
    onArcgisValueChange: "arcgisValueChange",
}));
export const ArcgisFeatureTable = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-feature-table", {
    onArcgisCellClick: "arcgisCellClick",
    onArcgisCellKeydown: "arcgisCellKeydown",
    onArcgisCellPointerout: "arcgisCellPointerout",
    onArcgisCellPointerover: "arcgisCellPointerover",
    onArcgisColumnReorder: "arcgisColumnReorder",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSelectionChange: "arcgisSelectionChange",
}));
export const ArcgisFeatureTemplates = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-feature-templates", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSelect: "arcgisSelect",
}));
export const ArcgisFeatures = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-features", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisTriggerAction: "arcgisTriggerAction",
}));
export const ArcgisFloorFilter = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-floor-filter", {
    onArcgisReady: "arcgisReady",
}));
export const ArcgisFullscreen = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-fullscreen", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisHistogram = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-histogram", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisHistogramRangeSlider = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-histogram-range-slider", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisHome = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-home", {
    onArcgisGo: "arcgisGo",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisLayerList = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-layer-list", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisTriggerAction: "arcgisTriggerAction",
}));
export const ArcgisLegend = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-legend", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisLineOfSight = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-line-of-sight", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisLinkChart = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-link-chart", {
    onArcgisViewChange: "arcgisViewChange",
    onArcgisViewClick: "arcgisViewClick",
    onArcgisViewDoubleClick: "arcgisViewDoubleClick",
    onArcgisViewDrag: "arcgisViewDrag",
    onArcgisViewHold: "arcgisViewHold",
    onArcgisViewImmediateClick: "arcgisViewImmediateClick",
    onArcgisViewImmediateDoubleClick: "arcgisViewImmediateDoubleClick",
    onArcgisViewKeyDown: "arcgisViewKeyDown",
    onArcgisViewKeyUp: "arcgisViewKeyUp",
    onArcgisViewLayerviewCreate: "arcgisViewLayerviewCreate",
    onArcgisViewLayerviewCreateError: "arcgisViewLayerviewCreateError",
    onArcgisViewLayerviewDestroy: "arcgisViewLayerviewDestroy",
    onArcgisViewMouseWheel: "arcgisViewMouseWheel",
    onArcgisViewPointerDown: "arcgisViewPointerDown",
    onArcgisViewPointerEnter: "arcgisViewPointerEnter",
    onArcgisViewPointerLeave: "arcgisViewPointerLeave",
    onArcgisViewPointerMove: "arcgisViewPointerMove",
    onArcgisViewPointerUp: "arcgisViewPointerUp",
    onArcgisViewReadyChange: "arcgisViewReadyChange",
}));
export const ArcgisLinkChartLayoutSwitcher = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-link-chart-layout-switcher", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSwitchLayout: "arcgisSwitchLayout",
}));
export const ArcgisLocate = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-locate", {
    onArcgisError: "arcgisError",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSuccess: "arcgisSuccess",
}));
export const ArcgisMap = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-map", {
    onArcgisViewChange: "arcgisViewChange",
    onArcgisViewClick: "arcgisViewClick",
    onArcgisViewDoubleClick: "arcgisViewDoubleClick",
    onArcgisViewDrag: "arcgisViewDrag",
    onArcgisViewHold: "arcgisViewHold",
    onArcgisViewImmediateClick: "arcgisViewImmediateClick",
    onArcgisViewImmediateDoubleClick: "arcgisViewImmediateDoubleClick",
    onArcgisViewKeyDown: "arcgisViewKeyDown",
    onArcgisViewKeyUp: "arcgisViewKeyUp",
    onArcgisViewLayerviewCreate: "arcgisViewLayerviewCreate",
    onArcgisViewLayerviewCreateError: "arcgisViewLayerviewCreateError",
    onArcgisViewLayerviewDestroy: "arcgisViewLayerviewDestroy",
    onArcgisViewMouseWheel: "arcgisViewMouseWheel",
    onArcgisViewPointerDown: "arcgisViewPointerDown",
    onArcgisViewPointerEnter: "arcgisViewPointerEnter",
    onArcgisViewPointerLeave: "arcgisViewPointerLeave",
    onArcgisViewPointerMove: "arcgisViewPointerMove",
    onArcgisViewPointerUp: "arcgisViewPointerUp",
    onArcgisViewReadyChange: "arcgisViewReadyChange",
}));
export const ArcgisMeasurement = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-measurement", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisNavigationToggle = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-navigation-toggle", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisOrientedImageryViewer = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-oriented-imagery-viewer", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisPlacement = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-placement", {
    onArcgisReady: "arcgisReady",
}));
export const ArcgisPrint = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-print", {
    onArcgisComplete: "arcgisComplete",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSubmit: "arcgisSubmit",
}));
export const ArcgisScaleBar = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-scale-bar", {
    onArcgisReady: "arcgisReady",
}));
export const ArcgisScaleRangeSlider = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-scale-range-slider", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisScene = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-scene", {
    onArcgisViewChange: "arcgisViewChange",
    onArcgisViewClick: "arcgisViewClick",
    onArcgisViewDoubleClick: "arcgisViewDoubleClick",
    onArcgisViewDrag: "arcgisViewDrag",
    onArcgisViewHold: "arcgisViewHold",
    onArcgisViewImmediateClick: "arcgisViewImmediateClick",
    onArcgisViewImmediateDoubleClick: "arcgisViewImmediateDoubleClick",
    onArcgisViewKeyDown: "arcgisViewKeyDown",
    onArcgisViewKeyUp: "arcgisViewKeyUp",
    onArcgisViewLayerviewCreate: "arcgisViewLayerviewCreate",
    onArcgisViewLayerviewCreateError: "arcgisViewLayerviewCreateError",
    onArcgisViewLayerviewDestroy: "arcgisViewLayerviewDestroy",
    onArcgisViewMouseWheel: "arcgisViewMouseWheel",
    onArcgisViewPointerDown: "arcgisViewPointerDown",
    onArcgisViewPointerEnter: "arcgisViewPointerEnter",
    onArcgisViewPointerLeave: "arcgisViewPointerLeave",
    onArcgisViewPointerMove: "arcgisViewPointerMove",
    onArcgisViewPointerUp: "arcgisViewPointerUp",
    onArcgisViewReadyChange: "arcgisViewReadyChange",
}));
export const ArcgisSearch = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-search", {
    onArcgisBlur: "arcgisBlur",
    onArcgisClear: "arcgisClear",
    onArcgisComplete: "arcgisComplete",
    onArcgisFocus: "arcgisFocus",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSelectResult: "arcgisSelectResult",
    onArcgisStart: "arcgisStart",
    onArcgisSuggestComplete: "arcgisSuggestComplete",
    onArcgisSuggestStart: "arcgisSuggestStart",
}));
export const ArcgisShadowCast = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-shadow-cast", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisSketch = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-sketch", {
    onArcgisCreate: "arcgisCreate",
    onArcgisDelete: "arcgisDelete",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisRedo: "arcgisRedo",
    onArcgisUndo: "arcgisUndo",
    onArcgisUpdate: "arcgisUpdate",
}));
export const ArcgisSlice = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-slice", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisSlider = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-slider", {
    onArcgisMaxChange: "arcgisMaxChange",
    onArcgisMaxClick: "arcgisMaxClick",
    onArcgisMinChange: "arcgisMinChange",
    onArcgisMinClick: "arcgisMinClick",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisSegmentClick: "arcgisSegmentClick",
    onArcgisSegmentDrag: "arcgisSegmentDrag",
    onArcgisThumbChange: "arcgisThumbChange",
    onArcgisThumbClick: "arcgisThumbClick",
    onArcgisThumbDrag: "arcgisThumbDrag",
    onArcgisTickClick: "arcgisTickClick",
    onArcgisTrackClick: "arcgisTrackClick",
}));
export const ArcgisSwipe = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-swipe", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisTableList = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-table-list", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisTriggerAction: "arcgisTriggerAction",
}));
export const ArcgisTimeSlider = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-time-slider", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
    onArcgisTriggerAction: "arcgisTriggerAction",
}));
export const ArcgisTrack = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-track", {
    onArcgisComplete: "arcgisComplete",
    onArcgisError: "arcgisError",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisUtilityNetworkAssociations = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-utility-network-associations", {
    onArcgisReady: "arcgisReady",
}));
export const ArcgisUtilityNetworkTrace = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-utility-network-trace", {
    onArcgisAddFlag: "arcgisAddFlag",
    onArcgisAddFlagComplete: "arcgisAddFlagComplete",
    onArcgisAddFlagError: "arcgisAddFlagError",
    onArcgisAddResultArea: "arcgisAddResultArea",
    onArcgisReady: "arcgisReady",
    onArcgisRemoveResultArea: "arcgisRemoveResultArea",
}));
export const ArcgisUtilityNetworkValidateTopology = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-utility-network-validate-topology", {
    onArcgisReady: "arcgisReady",
}));
export const ArcgisValuePicker = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-value-picker", {
    onArcgisAnimate: "arcgisAnimate",
    onArcgisNext: "arcgisNext",
    onArcgisPause: "arcgisPause",
    onArcgisPlay: "arcgisPlay",
    onArcgisPrevious: "arcgisPrevious",
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisVersionManagement = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-version-management", {
    onArcgisReady: "arcgisReady",
    onArcgisVersioningStateChanged: "arcgisVersioningStateChanged",
}));
export const ArcgisWeather = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-weather", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
export const ArcgisZoom = /*@__PURE__*/ createWrapper(getReactWrapperOptions("arcgis-zoom", {
    onArcgisPropertyChange: "arcgisPropertyChange",
    onArcgisReady: "arcgisReady",
}));
